<template>
  <b-card>
    <validation-observer
      ref="accountSettingSocialForm"
      #default="{ invalid }"
    >
      <b-form @submit.prevent="saveForm">
        <b-row>
          <b-col cols="12">
            <div class="d-flex align-items-center mb-2">
              <feather-icon
                icon="LinkIcon"
                size="18"
              />
              <h4 class="mb-0 ml-75">
                Social Links
              </h4>
            </div>
          </b-col>

          <!-- website -->
          <b-col md="6">
            <b-form-group
              label-for="account-websiteLink"
              label="Website"
            >
              <validation-provider
                #default="{ errors }"
                name="websiteLink"
                vid="websiteLink"
                rules="required"
              >
                <b-form-input
                  id="account-websiteLink"
                  v-model="socialLocal.websiteLink"
                  name="account-websiteLink"
                  placeholder="Add website link"
                  :state="errors.length > 0 ? false : null"
                  required
                  :class="{'cursor-not-allowed': isNotEntityAdmin}"
                  :disabled="isNotEntityAdmin"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ website -->

          <!-- twitter -->
          <b-col md="6">
            <b-form-group
              label-for="account-twitter"
              label="Twitter"
            >
              <b-form-input
                id="account-twitter"
                v-model="socialLocal.twitterLink"
                placeholder="Add twitter link"
                :class="{'cursor-not-allowed': isNotEntityAdmin}"
                :disabled="isNotEntityAdmin"
              />
            </b-form-group>
          </b-col>
          <!--/ twitter -->

          <!-- facebook -->
          <b-col md="6">
            <b-form-group
              label-for="account-facebook"
              label="Facebook"
            >
              <b-form-input
                id="account-facebook"
                v-model="socialLocal.facebookLink"
                placeholder="Add facebook link"
                :class="{'cursor-not-allowed': isNotEntityAdmin}"
                :disabled="isNotEntityAdmin"
              />
            </b-form-group>
          </b-col>
          <!--/ facebook -->

          <!-- instagram -->
          <b-col md="6">
            <b-form-group
              label="Instagram"
              label-for="account-instagram"
            >
              <b-form-input
                id="account-instagram"
                v-model="socialLocal.instagramLink"
                placeholder="Add instagram link"
                :class="{'cursor-not-allowed': isNotEntityAdmin}"
                :disabled="isNotEntityAdmin"
              />
            </b-form-group>
          </b-col>
          <!--/ instagram -->

          <!-- linkedin -->
          <b-col md="6">
            <b-form-group
              label-for="account-linkedin"
              label="LinkedIn"
            >
              <b-form-input
                id="account-linkedin"
                v-model="socialLocal.linkedinLink"
                placeholder="Add linkedin link"
                :class="{'cursor-not-allowed': isNotEntityAdmin}"
                :disabled="isNotEntityAdmin"
              />
            </b-form-group>
          </b-col>
          <!-- linkedin -->

          <b-col cols="12">
            <hr class="my-2">
          </b-col>
          <!-- buttons -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              :class="isNotEntityAdmin ? 'disabled-btn' : ''"
              :disabled="invalid || saving || isNotEntityAdmin"
              @click.prevent="saveForm"
            >
              Save changes
              <feather-icon
                v-if="saving"
                icon="LoaderIcon"
              />
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              class="mt-1 ml-25"
              variant="outline-secondary"
              :class="isNotEntityAdmin ? 'disabled-btn' : ''"
              :disabled="isNotEntityAdmin"
              @click.prevent="resetForm"
            >
              Cancel
            </b-button>
          </b-col>
          <!--/ buttons -->
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useProfileSocial } from '@/composables/useProfileSocial'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    socialData: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const social = useProfileSocial()
    social.initSocial(props.socialData)
    const { saveForm: _saveForm, resetForm: _resetForm, ...socialRest } = social
    return {
      ...socialRest,
      _saveForm,
      _resetForm,
    }
  },
  emits: ['update-social'],
  methods: {
    async saveForm() {
      const success = await this.$refs.accountSettingSocialForm.validate()
      if (success) {
        const result = await this._saveForm()
        if (result?.success) {
          this.$emit('update-social', result.payload)
        }
      }
    },
    resetForm() {
      this._resetForm(this.socialData)
    },
  },
}
</script>
<style scoped>
.disabled-btn {
  cursor: not-allowed;
}
</style>
